import { apiRequest } from "@portal/lib/ky/utils";
import { Customer_UI_DTO } from "@portal/types/entities/customer";
import { PortalUI_DTO } from "@portal/types/entities/portalui";
import { UserUI_DV_DTO } from "@portal/types/entities/user";

export interface CurrentUser {
  customer: Customer_UI_DTO;
  portal: PortalUI_DTO;
  user: UserUI_DV_DTO;
}

export async function getCurrentUserConfig() {
  const response = await apiRequest<unknown, CurrentUser>({
    method: "GET",
    url: "v1/users/current-user",
  });
  return await response.json();
}

export async function getCustomerDefault() {
  const response = await apiRequest<
    unknown,
    {
      url: "string";
    }
  >({
    method: "GET",
    url: "v1/customers/default",
  });
  return await response.json();
}
